import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import rest from '../axios';
import './login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const flashMessage = location.state?.message;

  useEffect(() => {
    if (flashMessage) {
      setError(flashMessage);
    }
  }, [flashMessage]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    const formData = { email, password };

    try {
      const response = await rest.post('auth/login', formData);

      if (response.status === 201) {
        const { token, user } = response.data;

        if (user?.contact_type !== 'admin') {
          setError('Acesso permitido apenas para administradores.');
          return;
        }

        localStorage.setItem('token', token);
        localStorage.setItem('name', user?.name);
        navigate('/dashboard', { state: { token } });
      } else {
        setError('Credenciais inválidas');
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      setError('Credenciais inválidas problema de conexao com o backend');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid login-bg d-flex align-items-center justify-content-center vh-100">
      <div className="login-card text-white text-center">
        <img src="/image.png" alt="Logo Conexxi" className="logo-img" />

        <h2>Bem-vindo à Conexxi Admin!</h2>
        <p>Por favor, faça login para acessar o painel de administração.</p>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleSubmit} className="text-start">
          <div className="mb-3">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              id="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="Digite seu email"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="form-label">Senha</label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Digite sua senha"
            />
          </div>

          <div className="d-flex justify-content-center mb-4">
            <button
              type="submit"
              className="btn btn-primary w-100 d-flex justify-content-center align-items-center"
              disabled={loading}>
              {loading ? (
                <span className="d-flex justify-content-center align-items-center">
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Entrando...
                </span>
              ) : (
                'Entrar'
              )}
            </button>
          </div>
        </form>


      </div>
    </div>
  );
};

export default Login;
